import { clampView, isZoomed } from '../components/video/videoView'

// A viewer who can't edit a video keeps their own view of it on this device. Storage can be
// blocked or full; then the view simply isn't remembered.
const key = uploadId => `highlights.videoView.${uploadId}`

export const localVideoView = uploadId => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(key(uploadId)) || 'null')
    return stored ? clampView(stored) : null
  } catch (_) {
    return null
  }
}

export const rememberLocalVideoView = (uploadId, view) => {
  try {
    if (isZoomed(view)) window.localStorage.setItem(key(uploadId), JSON.stringify(clampView(view)))
    else window.localStorage.removeItem(key(uploadId))
  } catch (_) {}
}
